import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import NumberCard from "../../../../components/Card/NumberCard";
import Table from "../../../../components/Table";
import { SecuronixTopThreatscolumns, SecuronixThreatscolumns } from "../../../../components/headerContent";
import RowThreats from "./RowtThreats";
import Loader from "../../../../components/Loader";
import { useTranslation } from "react-i18next";

export default function Threats({ date, threats }) {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getTopThreats = async () => {
        const res = await axios(`${apiUrl}securonix/topThreats`, {
            method: "get",
            withCredentials: true
        });
        return res.data;
    };

    const topThreats = useQuery({
        queryKey: ["dashboard"],
        queryFn: getTopThreats,
    });

    useEffect(() => {
        if (date[0] && date[1]) {
            threats.refetch();
        }
    }, [date, threats]);

    return (
        <>
            <section className="top-threats">
                <section className="page-section">
                    <NumberCard
                        title={t("Top Models de menaces") + " :"}
                    />
                </section>
                <div className='cato-content-table'>
                    {!topThreats.isLoading ? (
                        <Table
                            tableData={topThreats.data}
                            tableColumns={SecuronixTopThreatscolumns}
                            checkbox={false}
                        />
                    ) : (
                        <Loader />
                    )}
                </div>
            </section>
            {!threats.isLoading && !topThreats.isLoading ? (
                threats.data && threats.data.length > 0 ? (
                    <div className='cato-content-table'>
                        <section className="page-section">
                            <NumberCard
                                title={t("Menaces") + " :"}
                            />
                        </section>
                        <div className='cato-content-table'>
                            <Table
                                tableData={threats.data}
                                tableColumns={SecuronixThreatscolumns}
                                rowComponent={RowThreats}
                                checkbox={false}
                            />
                        </div>
                    </div>
                ) : (
                    <section className="no-data">
                        <h2 className="top-threats-title-securonix">{t("Aucune donnée trouvée pour les menaces")}</h2>
                    </section>
                )
            ) : (
                <Loader />
            )}
        </>
    );
}